import styled from 'styled-components'

export const Container = styled.div`
  form {
    h5 {
      margin-bottom: 10px;
    }
    button {
      &:first-of-type {
        margin-bottom: 0px;
      }
    }
  }
`
